import { render, staticRenderFns } from "./cards.vue?vue&type=template&id=ddc6a8fa"
import script from "./cards.vue?vue&type=script&lang=js"
export * from "./cards.vue?vue&type=script&lang=js"
import style0 from "./cards.vue?vue&type=style&index=0&id=ddc6a8fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/app/components/img.vue').default})
